import React, { ReactNode } from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    heroTitle: {
        alignSelf: 'stretch',
        margin: 0,
        maxWidth: '1204px',
        flex: '1 1 0',
    },

    heroTitleRegular: {
        color: '#F4F0E7',
        fontSize: '160px',
        fontFamily: 'Figtree',
        fontWeight: 300,
        lineHeight: '160px',
        wordWrap: 'break-word',
        '@media (max-width: 768px)': {
            fontSize: '52px',
            lineHeight: '52px',
        },
        '@media (max-width: 480px)': {
            fontSize: '40px',
            lineHeight: '40px',
        },
    },

    heroTitleItalic: {
        color: '#F4F0E7',
        fontSize: '160px',
        fontFamily: 'Behind The Nineties',
        fontStyle: 'italic',
        fontWeight: 400,
        lineHeight: '160px',
        wordWrap: 'break-word',
        '@media (max-width: 768px)': {
            fontSize: '52px',
            lineHeight: '52px',
        },
        '@media (max-width: 480px)': {
            fontSize: '40px',
            lineHeight: '40px',
        },
    },
});

export interface AlyzeHeroTitleProps {
    /** Regular (non-italic) text */
    regularText?: string;
    /** Italic text */
    italicText?: string;
    /** For complete custom children */
    children?: ReactNode;
}

export const AlyzeHeroTitle: React.FC<AlyzeHeroTitleProps> = ({
    regularText,
    italicText,
    children,
}) => {
    const styles = useStyles();

    if (children) {
        return <h1 className={styles.heroTitle}>{children}</h1>;
    }

    return (
        <h1 className={styles.heroTitle}>
            {regularText && <span className={styles.heroTitleRegular}>{regularText}</span>}
            {italicText && <span className={styles.heroTitleItalic}>{italicText}</span>}
        </h1>
    );
};
